import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontSize: 12,
  },
  content: {
    overflow: "auto",
    height: "87vh",
  },
}));
